import { initContract as Ae } from "@ts-rest/core";
import qe, { z as a } from "zod";
const Ne = "3.0.2", Se = {
  "/dataset/{datasetId}/locations": {
    get: {
      description: "Obtains all the locations for a dataset by the dataset ID, which by passing in the appropriate options, might be in different formats",
      summary: "obtains a dataset's locations",
      tags: [],
      parameters: [
        {
          name: "datasetId",
          in: "path",
          required: !0,
          schema: {
            type: "string",
            pattern: "^[A-Za-z0-9_-]+$"
          },
          description: "uniquely specifies the dataset wanted"
        }
      ],
      operationId: "getDatasetLocations",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                type: "array",
                items: {
                  type: "array",
                  items: {
                    type: "number"
                  },
                  minItems: 2,
                  maxItems: 2,
                  nullable: !0
                },
                description: "the dataset matching the supplied ID"
              }
            }
          }
        },
        400: {
          description: "400",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        },
        404: {
          description: "404",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        }
      }
    }
  },
  "/dataset/{datasetId}/search": {
    get: {
      description: "Obtains an array of dataset item indexes, which match the search criteria supplied",
      summary: "obtains a list of dataset entries satisfying the search criteria supplied",
      tags: [],
      parameters: [
        {
          name: "datasetId",
          in: "path",
          required: !0,
          schema: {
            type: "string",
            pattern: "^[A-Za-z0-9_-]+$"
          },
          description: "uniquely specifies the dataset wanted"
        },
        {
          name: "text",
          in: "query",
          description: "a text fragment to match",
          schema: {
            type: "string"
          }
        },
        {
          name: "filter",
          in: "query",
          description: "uniquely specifies the taxonomy filter items wanted",
          schema: {
            oneOf: [
              {
                type: "array",
                items: {
                  type: "string"
                }
              },
              {
                type: "string"
              }
            ]
          }
        },
        {
          name: "returnProps",
          in: "query",
          description: "The props to return as an array of item objects. If not specified, only an flattened array of indexes is returned.",
          schema: {
            type: "array",
            items: {
              type: "string"
            }
          }
        },
        {
          name: "page",
          in: "query",
          description: "The page number to return. If not specified, all items are returned.",
          schema: {
            type: "integer",
            minimum: 0,
            nullable: !0
          }
        },
        {
          name: "pageSize",
          in: "query",
          description: "The number of items per page. If not specified, all items are returned.",
          schema: {
            type: "integer",
            minimum: 0,
            exclusiveMinimum: 0
          }
        }
      ],
      operationId: "searchDataset",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                oneOf: [
                  {
                    type: "array",
                    items: {
                      type: "integer",
                      minimum: 0
                    }
                  },
                  {
                    type: "array",
                    items: {
                      allOf: [
                        {
                          type: "object",
                          additionalProperties: {
                            nullable: !0
                          }
                        },
                        {
                          type: "object",
                          properties: {
                            index: {
                              type: "integer",
                              minimum: 0
                            }
                          },
                          required: [
                            "index"
                          ]
                        }
                      ]
                    }
                  }
                ],
                description: "the dataset item indexes matching the supplied criteria"
              }
            }
          }
        },
        400: {
          description: "400",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        },
        404: {
          description: "404",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        }
      }
    }
  },
  "/dataset/{datasetId}/item/{datasetItemIdOrIx}": {
    get: {
      description: "Obtains a single dataset item by its ID or its index, and the dataset's ID.",
      summary: "obtains a dataset item by its unique ID",
      tags: [],
      parameters: [
        {
          name: "datasetId",
          in: "path",
          required: !0,
          schema: {
            type: "string",
            pattern: "^[A-Za-z0-9_-]+$"
          },
          description: "uniquely specifies the dataset wanted"
        },
        {
          name: "datasetItemIdOrIx",
          in: "path",
          required: !0,
          schema: {
            type: "string"
          },
          description: "Uniquely specifies the dataset item wanted within the dataset. This param must be base64 encoded. The decoded param should start with an @ to indicate an index, otherwise it is assumed to be an id"
        },
        {
          name: "returnProps",
          in: "query",
          description: "The props to return. If not specified, all props are returned. Note that the item's ID and index are always returned.",
          schema: {
            type: "array",
            items: {
              type: "string"
            }
          }
        }
      ],
      operationId: "getDatasetItem",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                allOf: [
                  {
                    allOf: [
                      {
                        type: "object",
                        properties: {
                          id: {
                            type: "string"
                          }
                        },
                        required: [
                          "id"
                        ]
                      },
                      {
                        type: "object",
                        additionalProperties: {
                          nullable: !0
                        }
                      }
                    ]
                  },
                  {
                    type: "object",
                    properties: {
                      index: {
                        type: "integer",
                        minimum: 0
                      }
                    },
                    required: [
                      "index"
                    ]
                  }
                ],
                description: "the dataset item matching the supplied ID or index"
              }
            }
          }
        },
        400: {
          description: "400",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        },
        404: {
          description: "404",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        }
      }
    }
  },
  "/dataset/{datasetId}/totals": {
    get: {
      description: "Gets the total number of results under each item in the directory.",
      summary: "get the total number of results under each item in the directory",
      tags: [],
      parameters: [
        {
          name: "datasetId",
          in: "path",
          required: !0,
          schema: {
            type: "string",
            pattern: "^[A-Za-z0-9_-]+$"
          },
          description: "uniquely specifies the dataset wanted"
        },
        {
          name: "filter",
          in: "query",
          description: "restricts the totals to items matching these taxonomy filters",
          schema: {
            oneOf: [
              {
                type: "array",
                items: {
                  type: "string"
                }
              },
              {
                type: "string"
              }
            ]
          }
        }
      ],
      operationId: "getTotals",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                type: "object",
                additionalProperties: {
                  type: "number"
                },
                description: "the total result numbers for a map"
              }
            }
          }
        },
        400: {
          description: "400",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        },
        404: {
          description: "404",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        }
      }
    }
  },
  "/dataset/{datasetId}/config": {
    get: {
      description: "Obtains configured parameters for a datset, which amongst other things, include default values for various options, and definitions of vocabulary terms with their localised labels, that are used to interpret identifers in the data and/or elsewhere.",
      summary: "obtain various configured parameters for a dataset",
      tags: [],
      parameters: [
        {
          name: "datasetId",
          in: "path",
          required: !0,
          schema: {
            type: "string",
            pattern: "^[A-Za-z0-9_-]+$"
          },
          description: "uniquely specifies the dataset wanted"
        }
      ],
      operationId: "getConfig",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  prefixes: {
                    type: "object",
                    additionalProperties: {
                      type: "string"
                    }
                  },
                  vocabs: {
                    type: "object",
                    additionalProperties: {
                      type: "object",
                      additionalProperties: {
                        type: "object",
                        properties: {
                          title: {
                            type: "string"
                          },
                          terms: {
                            type: "object",
                            additionalProperties: {
                              type: "string"
                            }
                          }
                        },
                        required: [
                          "title",
                          "terms"
                        ]
                      }
                    }
                  },
                  itemProps: {
                    allOf: [
                      {
                        type: "object",
                        properties: {
                          id: {
                            type: "object",
                            properties: {
                              from: {
                                type: "string"
                              },
                              titleUri: {
                                type: "string"
                              },
                              filter: {
                                type: "boolean",
                                enum: [
                                  !1
                                ]
                              },
                              search: {
                                type: "boolean"
                              },
                              type: {
                                type: "string",
                                enum: [
                                  "value"
                                ]
                              },
                              as: {
                                type: "string",
                                enum: [
                                  "string",
                                  "boolean",
                                  "number"
                                ]
                              },
                              strict: {
                                type: "boolean"
                              },
                              nullable: {
                                type: "boolean"
                              }
                            },
                            required: [
                              "type"
                            ]
                          }
                        },
                        required: [
                          "id"
                        ]
                      },
                      {
                        type: "object",
                        additionalProperties: {
                          discriminator: {
                            propertyName: "type"
                          },
                          oneOf: [
                            {
                              type: "object",
                              properties: {
                                from: {
                                  type: "string"
                                },
                                titleUri: {
                                  type: "string"
                                },
                                filter: {
                                  oneOf: [
                                    {
                                      type: "object",
                                      properties: {
                                        preset: {
                                          type: "boolean",
                                          enum: [
                                            !0
                                          ]
                                        },
                                        to: {
                                          nullable: !0
                                        }
                                      },
                                      required: [
                                        "preset"
                                      ]
                                    },
                                    {
                                      type: "boolean"
                                    }
                                  ]
                                },
                                search: {
                                  type: "boolean"
                                },
                                type: {
                                  type: "string",
                                  enum: [
                                    "value"
                                  ]
                                },
                                as: {
                                  type: "string",
                                  enum: [
                                    "string",
                                    "boolean",
                                    "number"
                                  ]
                                },
                                strict: {
                                  type: "boolean"
                                },
                                nullable: {
                                  type: "boolean"
                                }
                              },
                              required: [
                                "type"
                              ]
                            },
                            {
                              type: "object",
                              properties: {
                                from: {
                                  type: "string"
                                },
                                titleUri: {
                                  type: "string"
                                },
                                filter: {
                                  oneOf: [
                                    {
                                      type: "object",
                                      properties: {
                                        preset: {
                                          type: "boolean",
                                          enum: [
                                            !0
                                          ]
                                        },
                                        to: {
                                          nullable: !0
                                        }
                                      },
                                      required: [
                                        "preset"
                                      ]
                                    },
                                    {
                                      type: "boolean"
                                    }
                                  ]
                                },
                                search: {
                                  type: "boolean"
                                },
                                type: {
                                  type: "string",
                                  enum: [
                                    "vocab"
                                  ]
                                },
                                uri: {
                                  type: "string"
                                },
                                sorted: {
                                  oneOf: [
                                    {
                                      type: "boolean"
                                    },
                                    {
                                      type: "string",
                                      enum: [
                                        "asc"
                                      ]
                                    },
                                    {
                                      type: "string",
                                      enum: [
                                        "desc"
                                      ]
                                    }
                                  ]
                                }
                              },
                              required: [
                                "type",
                                "uri"
                              ]
                            },
                            {
                              type: "object",
                              properties: {
                                from: {
                                  type: "string"
                                },
                                titleUri: {
                                  type: "string"
                                },
                                filter: {
                                  oneOf: [
                                    {
                                      type: "object",
                                      properties: {
                                        preset: {
                                          type: "boolean",
                                          enum: [
                                            !0
                                          ]
                                        },
                                        to: {
                                          nullable: !0
                                        }
                                      },
                                      required: [
                                        "preset"
                                      ]
                                    },
                                    {
                                      type: "boolean"
                                    }
                                  ]
                                },
                                search: {
                                  type: "boolean"
                                },
                                type: {
                                  type: "string",
                                  enum: [
                                    "multi"
                                  ]
                                },
                                of: {
                                  oneOf: [
                                    {
                                      type: "object",
                                      properties: {
                                        type: {
                                          type: "string",
                                          enum: [
                                            "value"
                                          ]
                                        },
                                        as: {
                                          type: "string",
                                          enum: [
                                            "string",
                                            "boolean",
                                            "number"
                                          ]
                                        },
                                        strict: {
                                          type: "boolean"
                                        },
                                        nullable: {
                                          type: "boolean"
                                        }
                                      },
                                      required: [
                                        "type"
                                      ]
                                    },
                                    {
                                      type: "object",
                                      properties: {
                                        type: {
                                          type: "string",
                                          enum: [
                                            "vocab"
                                          ]
                                        },
                                        uri: {
                                          type: "string"
                                        },
                                        sorted: {
                                          oneOf: [
                                            {
                                              type: "boolean"
                                            },
                                            {
                                              type: "string",
                                              enum: [
                                                "asc"
                                              ]
                                            },
                                            {
                                              type: "string",
                                              enum: [
                                                "desc"
                                              ]
                                            }
                                          ]
                                        }
                                      },
                                      required: [
                                        "type",
                                        "uri"
                                      ]
                                    }
                                  ]
                                }
                              },
                              required: [
                                "type",
                                "of"
                              ]
                            }
                          ]
                        }
                      }
                    ]
                  },
                  languages: {
                    type: "array",
                    items: {
                      type: "string",
                      enum: [
                        "aa",
                        "ab",
                        "ae",
                        "af",
                        "ak",
                        "am",
                        "an",
                        "ar",
                        "as",
                        "av",
                        "ay",
                        "az",
                        "ba",
                        "be",
                        "bg",
                        "bi",
                        "bm",
                        "bn",
                        "bo",
                        "br",
                        "bs",
                        "ca",
                        "ce",
                        "ch",
                        "co",
                        "cr",
                        "cs",
                        "cu",
                        "cv",
                        "cy",
                        "da",
                        "de",
                        "dv",
                        "dz",
                        "ee",
                        "el",
                        "en",
                        "eo",
                        "es",
                        "et",
                        "eu",
                        "fa",
                        "ff",
                        "fi",
                        "fj",
                        "fo",
                        "fr",
                        "fy",
                        "ga",
                        "gd",
                        "gl",
                        "gn",
                        "gu",
                        "gv",
                        "ha",
                        "he",
                        "hi",
                        "ho",
                        "hr",
                        "ht",
                        "hu",
                        "hy",
                        "hz",
                        "ia",
                        "id",
                        "ie",
                        "ig",
                        "ii",
                        "ik",
                        "io",
                        "is",
                        "it",
                        "iu",
                        "ja",
                        "jv",
                        "ka",
                        "kg",
                        "ki",
                        "kj",
                        "kk",
                        "kl",
                        "km",
                        "kn",
                        "ko",
                        "kr",
                        "ks",
                        "ku",
                        "kv",
                        "kw",
                        "ky",
                        "la",
                        "lb",
                        "lg",
                        "li",
                        "ln",
                        "lo",
                        "lt",
                        "lu",
                        "lv",
                        "mg",
                        "mh",
                        "mi",
                        "mk",
                        "ml",
                        "mn",
                        "mr",
                        "ms",
                        "mt",
                        "my",
                        "na",
                        "nb",
                        "nd",
                        "ne",
                        "ng",
                        "nl",
                        "nn",
                        "no",
                        "nr",
                        "nv",
                        "ny",
                        "oc",
                        "oj",
                        "om",
                        "or",
                        "os",
                        "pa",
                        "pi",
                        "pl",
                        "ps",
                        "pt",
                        "qu",
                        "rm",
                        "rn",
                        "ro",
                        "ru",
                        "rw",
                        "sa",
                        "sc",
                        "sd",
                        "se",
                        "sg",
                        "si",
                        "sk",
                        "sl",
                        "sm",
                        "sn",
                        "so",
                        "sq",
                        "sr",
                        "ss",
                        "st",
                        "su",
                        "sv",
                        "sw",
                        "ta",
                        "te",
                        "tg",
                        "th",
                        "ti",
                        "tk",
                        "tl",
                        "tn",
                        "to",
                        "tr",
                        "ts",
                        "tt",
                        "tw",
                        "ty",
                        "ug",
                        "uk",
                        "ur",
                        "uz",
                        "ve",
                        "vi",
                        "vo",
                        "wa",
                        "wo",
                        "xh",
                        "yi",
                        "yo",
                        "za",
                        "zh",
                        "zu"
                      ]
                    },
                    minItems: 1
                  },
                  submaps: {
                    type: "object",
                    additionalProperties: {
                      type: "object",
                      properties: {
                        lockedFilter: {
                          type: "array",
                          items: {
                            type: "string"
                          },
                          minItems: 1
                        },
                        mapBounds: {},
                        aboutPrefix: {
                          type: "string"
                        },
                        title: {
                          type: "string"
                        }
                      },
                      required: [
                        "lockedFilter"
                      ]
                    }
                  },
                  ui: {
                    type: "object",
                    properties: {
                      directory_panel_field: {
                        type: "string"
                      },
                      title: {
                        type: "string"
                      },
                      dataLastUpdated: {
                        type: "string",
                        format: "date-time"
                      },
                      show_map_key: {
                        type: "boolean"
                      },
                      customMarkers: {
                        type: "object",
                        properties: {
                          marker_property_name: {
                            type: "string"
                          },
                          markerIcons: {
                            type: "array",
                            items: {
                              type: "string"
                            }
                          },
                          termsToIconIndex: {
                            allOf: [
                              {
                                type: "object",
                                properties: {
                                  default: {
                                    type: "number"
                                  }
                                },
                                required: [
                                  "default"
                                ]
                              },
                              {
                                type: "object",
                                additionalProperties: {
                                  type: "number"
                                }
                              }
                            ]
                          }
                        },
                        required: [
                          "marker_property_name",
                          "markerIcons",
                          "termsToIconIndex"
                        ]
                      },
                      map: {
                        type: "object",
                        properties: {
                          mapBounds: {}
                        }
                      },
                      logo: {
                        type: "object",
                        properties: {
                          largeLogo: {
                            type: "string"
                          },
                          smallLogo: {
                            type: "string"
                          },
                          altText: {
                            type: "string"
                          },
                          smallScreenPosition: {
                            type: "object",
                            properties: {
                              top: {
                                type: "string"
                              },
                              left: {
                                type: "string"
                              }
                            }
                          },
                          largeScreenPosition: {
                            type: "object",
                            properties: {
                              bottom: {
                                type: "string"
                              },
                              right: {
                                type: "string"
                              }
                            }
                          }
                        }
                      }
                    },
                    required: [
                      "directory_panel_field"
                    ]
                  },
                  popup: {
                    type: "object",
                    properties: {
                      titleProp: {
                        type: "string"
                      },
                      leftPaneWidth: {
                        default: "70%",
                        type: "string"
                      },
                      leftPane: {
                        type: "array",
                        items: {
                          type: "object",
                          properties: {
                            itemProp: {
                              type: "string"
                            },
                            valueStyle: {
                              default: "text",
                              type: "string",
                              enum: [
                                "text",
                                "address",
                                "hyperlink"
                              ]
                            },
                            showBullets: {
                              default: !1,
                              type: "boolean"
                            },
                            singleColumnLimit: {
                              type: "number"
                            },
                            showLabel: {
                              default: !1,
                              type: "boolean"
                            },
                            hyperlinkBaseUri: {
                              default: "",
                              type: "string"
                            },
                            displayText: {
                              type: "string"
                            },
                            analyticOnClick: {
                              default: !1,
                              type: "boolean"
                            }
                          },
                          required: [
                            "itemProp"
                          ]
                        }
                      },
                      topRightPane: {
                        type: "array",
                        items: {
                          type: "object",
                          properties: {
                            itemProp: {
                              type: "string"
                            },
                            valueStyle: {
                              default: "text",
                              type: "string",
                              enum: [
                                "text",
                                "address",
                                "hyperlink"
                              ]
                            },
                            showBullets: {
                              default: !1,
                              type: "boolean"
                            },
                            singleColumnLimit: {
                              type: "number"
                            },
                            showLabel: {
                              default: !1,
                              type: "boolean"
                            },
                            hyperlinkBaseUri: {
                              default: "",
                              type: "string"
                            },
                            displayText: {
                              type: "string"
                            },
                            analyticOnClick: {
                              default: !1,
                              type: "boolean"
                            }
                          },
                          required: [
                            "itemProp"
                          ]
                        }
                      },
                      bottomRightPane: {
                        type: "array",
                        items: {
                          type: "object",
                          properties: {
                            itemProp: {
                              type: "string"
                            },
                            valueStyle: {
                              default: "text",
                              type: "string",
                              enum: [
                                "text",
                                "address",
                                "hyperlink"
                              ]
                            },
                            showBullets: {
                              default: !1,
                              type: "boolean"
                            },
                            singleColumnLimit: {
                              type: "number"
                            },
                            showLabel: {
                              default: !1,
                              type: "boolean"
                            },
                            hyperlinkBaseUri: {
                              default: "",
                              type: "string"
                            },
                            displayText: {
                              type: "string"
                            },
                            analyticOnClick: {
                              default: !1,
                              type: "boolean"
                            }
                          },
                          required: [
                            "itemProp"
                          ]
                        }
                      }
                    },
                    required: [
                      "titleProp",
                      "leftPane",
                      "topRightPane",
                      "bottomRightPane"
                    ]
                  }
                },
                required: [
                  "prefixes",
                  "vocabs",
                  "itemProps",
                  "languages",
                  "ui",
                  "popup"
                ],
                description: "various configured parameters for a map"
              }
            }
          }
        },
        400: {
          description: "400",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        },
        404: {
          description: "404",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        }
      }
    }
  },
  "/dataset/{datasetId}/about": {
    get: {
      description: "Obtains information about the datset, in markdown format so it can be easily rendered on a front-end application.",
      summary: "obtain the About text for a dataset",
      tags: [],
      parameters: [
        {
          name: "datasetId",
          in: "path",
          required: !0,
          schema: {
            type: "string",
            pattern: "^[A-Za-z0-9_-]+$"
          },
          description: "uniquely specifies the dataset wanted"
        }
      ],
      operationId: "getAbout",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                type: "string",
                description: "About text in markdown format"
              }
            }
          }
        },
        400: {
          description: "400",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        },
        404: {
          description: "404",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        }
      }
    }
  },
  "/version": {
    get: {
      description: "Obtains version information about the backend Mykomap server, in the form of a JSON object",
      summary: "obtains Mykomap server version information",
      tags: [],
      parameters: [],
      operationId: "getVersion",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  name: {
                    type: "string"
                  },
                  buildTime: {
                    type: "string",
                    format: "date-time"
                  },
                  version: {
                    type: "string"
                  },
                  commitDesc: {
                    type: "string"
                  },
                  nodeEnv: {
                    type: "string"
                  }
                },
                required: [
                  "name",
                  "buildTime",
                  "version",
                  "commitDesc",
                  "nodeEnv"
                ],
                description: "information about the current Mykomap server build"
              }
            }
          }
        }
      }
    }
  },
  "/datasets": {
    get: {
      description: "Returns an array of the datasets available on this server, each entry carrying the dataset ID, a human-readable label (taken from config.ui.logo.altText, falling back to the ID), and the dataset's submaps (key and title), if any. A dataset that is a symlink to another dataset (such as cwm-latest) also carries aliasOf, the ID of the dataset it points at.",
      summary: "lists the datasets available on this server",
      tags: [],
      parameters: [],
      operationId: "listDatasets",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    id: {
                      type: "string",
                      pattern: "^[A-Za-z0-9_-]+$",
                      description: "uniquely specifies the dataset wanted"
                    },
                    label: {
                      type: "string"
                    },
                    aliasOf: {
                      type: "string",
                      pattern: "^[A-Za-z0-9_-]+$",
                      description: "uniquely specifies the dataset wanted"
                    },
                    submaps: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          key: {
                            type: "string"
                          },
                          title: {
                            type: "string"
                          }
                        },
                        required: [
                          "key",
                          "title"
                        ]
                      }
                    }
                  },
                  required: [
                    "id",
                    "label"
                  ]
                },
                description: "the list of available datasets"
              }
            }
          }
        }
      }
    }
  }
}, Te = {
  title: "Mykomap basic data and search API",
  description: "This is a basic API for Mykomap application clients",
  contact: {
    email: "hello@digitalcommons.coop"
  },
  license: {
    name: "Apache 2.0",
    url: "http://www.apache.org/licenses/LICENSE-2.0.html"
  },
  version: "0.1.0"
}, At = {
  openapi: Ne,
  paths: Se,
  info: Te
}, h = /* @__PURE__ */ (() => {
  const e = (o) => o instanceof RegExp ? o.source : o, t = (o, ...l) => {
    switch (l.length) {
      case 0:
        return "";
      case 1:
        return `(?:${e(l[0])})`;
      default:
        return "(?:" + l.map((g) => `(?:${e(g)})`).join(o) + ")";
    }
  };
  return { conc: (...o) => new RegExp(o.map((l) => e(l)).join("")), maybe: (...o) => {
    const l = t("|", ...o);
    return new RegExp(`${l}?`);
  }, min: (o, ...l) => {
    const g = t("|", ...l);
    switch (o) {
      case 0:
        return new RegExp(`${g}*`);
      case 1:
        return new RegExp(`${g}+`);
    }
  }, seq: (...o) => new RegExp(t("", ...o)), oneOf: (...o) => new RegExp(t("|", ...o)), uaon: (o) => {
    let [l, g] = o instanceof RegExp ? [o.source, o.flags] : [o, ""];
    return l = l.replace(/^\^?/ms, "^"), l = l.replace(/\$?$/ms, "$"), g = [...new Set((g + "msu").split(""))].join(""), new RegExp(l, g);
  }, wrap: (o, ...l) => new RegExp(t(o, ...l)) };
})();
var _ = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, X = {}, j = {}, U = {};
Object.defineProperty(U, "__esModule", { value: !0 });
const V = (e) => {
  if (typeof e == "object" && e !== null) {
    if (typeof Object.getPrototypeOf == "function") {
      const t = Object.getPrototypeOf(e);
      return t === Object.prototype || t === null;
    }
    return Object.prototype.toString.call(e) === "[object Object]";
  }
  return !1;
}, y = (...e) => e.reduce((t, i) => {
  if (Array.isArray(i))
    throw new TypeError("Arguments provided to ts-deepmerge must be objects, not arrays.");
  return Object.keys(i).forEach((n) => {
    ["__proto__", "constructor", "prototype"].includes(n) || (Array.isArray(t[n]) && Array.isArray(i[n]) ? t[n] = y.options.mergeArrays ? y.options.uniqueArrayItems ? Array.from(new Set(t[n].concat(i[n]))) : [...t[n], ...i[n]] : i[n] : V(t[n]) && V(i[n]) ? t[n] = y(t[n], i[n]) : t[n] = i[n] === void 0 ? y.options.allowUndefinedOverrides ? i[n] : t[n] : i[n]);
  }), t;
}, {}), E = {
  allowUndefinedOverrides: !0,
  mergeArrays: !0,
  uniqueArrayItems: !0
};
y.options = E;
y.withOptions = (e, ...t) => {
  y.options = Object.assign(Object.assign({}, E), e);
  const i = y(...t);
  return y.options = E, i;
};
U.default = y;
Object.defineProperty(j, "__esModule", { value: !0 });
j.generateSchema = j.extendApi = void 0;
const p = U, D = qe;
function Ze(e, t = {}) {
  return e.metaOpenApi = Object.assign(e.metaOpenApi || {}, t), e;
}
j.extendApi = Ze;
function Ee({ zodRef: e, useOutput: t }) {
  return Object.keys(e.shape).reduce((i, n) => Object.assign(Object.assign({}, i), { [n]: u(e.shape[n], t) }), {});
}
function F({ zodRef: e, schemas: t, useOutput: i }) {
  const n = u(e._def.schema, i);
  let r = "undefined";
  if (i && e._def.effect) {
    const s = e._def.effect.type === "transform" ? e._def.effect : null;
    if (s && "transform" in s)
      try {
        r = typeof s.transform(
          ["integer", "number"].includes(`${n.type}`) ? 0 : n.type === "string" ? "" : n.type === "boolean" ? !1 : n.type === "object" ? {} : n.type === "null" ? null : n.type === "array" ? [] : void 0,
          { addIssue: () => {
          }, path: [] }
          // TODO: Discover if context is necessary here
        );
      } catch {
      }
  }
  return (0, p.default)(Object.assign(Object.assign(Object.assign({}, e.description ? { description: e.description } : {}), n), ["number", "string", "boolean", "null"].includes(r) ? {
    type: r
  } : {}), ...t);
}
function Le({ zodRef: e, schemas: t }) {
  const i = {
    type: "string"
  }, { checks: n = [] } = e._def;
  return n.forEach((r) => {
    switch (r.kind) {
      case "email":
        i.format = "email";
        break;
      case "uuid":
        i.format = "uuid";
        break;
      case "cuid":
        i.format = "cuid";
        break;
      case "url":
        i.format = "uri";
        break;
      case "datetime":
        i.format = "date-time";
        break;
      case "length":
        i.minLength = r.value, i.maxLength = r.value;
        break;
      case "max":
        i.maxLength = r.value;
        break;
      case "min":
        i.minLength = r.value;
        break;
      case "regex":
        i.pattern = r.regex.source;
        break;
    }
  }), (0, p.default)(i, e.description ? { description: e.description } : {}, ...t);
}
function Ue({ zodRef: e, schemas: t }) {
  const i = {
    type: "number"
  }, { checks: n = [] } = e._def;
  return n.forEach((r) => {
    switch (r.kind) {
      case "max":
        i.maximum = r.value, r.inclusive || (i.exclusiveMaximum = r.value);
        break;
      case "min":
        i.minimum = r.value, r.inclusive || (i.exclusiveMinimum = r.value);
        break;
      case "int":
        i.type = "integer";
        break;
      case "multipleOf":
        i.multipleOf = r.value;
    }
  }), (0, p.default)(i, e.description ? { description: e.description } : {}, ...t);
}
function Me({ zodRef: e, schemas: t, useOutput: i }) {
  var n;
  let r;
  e._def.catchall instanceof D.z.ZodNever || ((n = e._def.catchall) === null || n === void 0 ? void 0 : n._def.typeName) === "ZodNever" ? e._def.unknownKeys === "passthrough" ? r = !0 : e._def.unknownKeys === "strict" && (r = !1) : r = u(e._def.catchall, i), r = r != null ? { additionalProperties: r } : {};
  const s = Object.keys(e.shape).filter((m) => {
    const w = e.shape[m];
    return !(w.isOptional() || w instanceof D.z.ZodDefault || w._def.typeName === "ZodDefault") && !(w instanceof D.z.ZodNever || w._def.typeName === "ZodDefault");
  }), c = s.length > 0 ? { required: s } : {};
  return (0, p.default)(Object.assign(Object.assign({ type: "object", properties: Ee({
    zodRef: e,
    useOutput: i
  }) }, c), r), e.description ? { description: e.description } : {}, ...t);
}
function Ce({ zodRef: e, schemas: t, useOutput: i }) {
  return (0, p.default)({
    type: "object",
    additionalProperties: e._def.valueType instanceof D.z.ZodUnknown ? {} : u(e._def.valueType, i)
  }, e.description ? { description: e.description } : {}, ...t);
}
function Be({ zodRef: e, schemas: t }) {
  return (0, p.default)({ type: "integer", format: "int64" }, e.description ? { description: e.description } : {}, ...t);
}
function $e({ zodRef: e, schemas: t }) {
  return (0, p.default)({ type: "boolean" }, e.description ? { description: e.description } : {}, ...t);
}
function Ve({ zodRef: e, schemas: t }) {
  return (0, p.default)({ type: "string", format: "date-time" }, e.description ? { description: e.description } : {}, ...t);
}
function Fe({ zodRef: e, schemas: t }) {
  return (0, p.default)({
    type: "string",
    format: "null",
    nullable: !0
  }, e.description ? { description: e.description } : {}, ...t);
}
function G({ schemas: e, zodRef: t, useOutput: i }) {
  return (0, p.default)(u(t.unwrap(), i), t.description ? { description: t.description } : {}, ...e);
}
function Ge({ schemas: e, zodRef: t, useOutput: i }) {
  return (0, p.default)(Object.assign({ default: t._def.defaultValue() }, u(t._def.innerType, i)), t.description ? { description: t.description } : {}, ...e);
}
function Ke({ schemas: e, zodRef: t, useOutput: i }) {
  const n = {};
  return t._def.exactLength != null && (n.minItems = t._def.exactLength.value, n.maxItems = t._def.exactLength.value), t._def.minLength != null && (n.minItems = t._def.minLength.value), t._def.maxLength != null && (n.maxItems = t._def.maxLength.value), (0, p.default)(Object.assign({ type: "array", items: u(t.element, i) }, n), t.description ? { description: t.description } : {}, ...e);
}
function We({ schemas: e, zodRef: t }) {
  return (0, p.default)({
    type: typeof t._def.value,
    enum: [t._def.value]
  }, t.description ? { description: t.description } : {}, ...e);
}
function K({ schemas: e, zodRef: t }) {
  return (0, p.default)({
    type: typeof Object.values(t._def.values)[0],
    enum: Object.values(t._def.values)
  }, t.description ? { description: t.description } : {}, ...e);
}
function Ye({ schemas: e, zodRef: t, useOutput: i }) {
  return (0, p.default)({
    allOf: [
      u(t._def.left, i),
      u(t._def.right, i)
    ]
  }, t.description ? { description: t.description } : {}, ...e);
}
function He({ schemas: e, zodRef: t, useOutput: i }) {
  const n = t._def.options;
  if (n.reduce((r, s) => r && s._def.typeName === "ZodLiteral", !0)) {
    const r = n, s = r.reduce((c, m) => !c || c === typeof m._def.value ? typeof m._def.value : null, null);
    if (s)
      return (0, p.default)({
        type: s,
        enum: r.map((c) => c._def.value)
      }, t.description ? { description: t.description } : {}, ...e);
  }
  return (0, p.default)({
    oneOf: n.map((r) => u(r, i))
  }, t.description ? { description: t.description } : {}, ...e);
}
function Qe({ schemas: e, zodRef: t, useOutput: i }) {
  return (0, p.default)({
    discriminator: {
      propertyName: t._def.discriminator
    },
    oneOf: Array.from(t._def.options.values()).map((n) => u(n, i))
  }, t.description ? { description: t.description } : {}, ...e);
}
function Je({ zodRef: e, schemas: t }) {
  return (0, p.default)({ readOnly: !0 }, e.description ? { description: e.description } : {}, ...t);
}
function Xe({ schemas: e, zodRef: t }) {
  return (0, p.default)(u(t._def.type), ...e);
}
function f({ zodRef: e, schemas: t }) {
  return (0, p.default)(e.description ? { description: e.description } : {}, ...t);
}
const W = {
  ZodObject: Me,
  ZodRecord: Ce,
  ZodString: Le,
  ZodNumber: Ue,
  ZodBigInt: Be,
  ZodBoolean: $e,
  ZodDate: Ve,
  ZodNull: Fe,
  ZodOptional: G,
  ZodNullable: G,
  ZodDefault: Ge,
  ZodArray: Ke,
  ZodLiteral: We,
  ZodEnum: K,
  ZodNativeEnum: K,
  ZodTransformer: F,
  ZodEffects: F,
  ZodIntersection: Ye,
  ZodUnion: He,
  ZodDiscriminatedUnion: Qe,
  ZodNever: Je,
  ZodBranded: Xe,
  // TODO Transform the rest to schemas
  ZodUndefined: f,
  // TODO: `prefixItems` is allowed in OpenAPI 3.1 which can be used to create tuples
  ZodTuple: f,
  ZodMap: f,
  ZodFunction: f,
  ZodLazy: f,
  ZodPromise: f,
  ZodAny: f,
  ZodUnknown: f,
  ZodVoid: f
};
function u(e, t) {
  const { metaOpenApi: i = {} } = e, n = [
    e.isNullable && e.isNullable() ? { nullable: !0 } : {},
    ...Array.isArray(i) ? i : [i]
  ];
  try {
    const r = e._def.typeName;
    return r in W ? W[r]({
      zodRef: e,
      schemas: n,
      useOutput: t
    }) : f({ zodRef: e, schemas: n });
  } catch (r) {
    return console.error(r), f({ zodRef: e, schemas: n });
  }
}
j.generateSchema = u;
var S = {};
Object.defineProperty(S, "__esModule", { value: !0 });
S.extendZodWithOpenApi = void 0;
const ze = j;
function Re(e, t = !1) {
  !t && typeof e.ZodSchema.prototype.openapi < "u" || (e.ZodSchema.prototype.openapi = function(i) {
    return (0, ze.extendApi)(this, i);
  });
}
S.extendZodWithOpenApi = Re;
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(n, r, s, c) {
    c === void 0 && (c = s);
    var m = Object.getOwnPropertyDescriptor(r, s);
    (!m || ("get" in m ? !r.__esModule : m.writable || m.configurable)) && (m = { enumerable: !0, get: function() {
      return r[s];
    } }), Object.defineProperty(n, c, m);
  } : function(n, r, s, c) {
    c === void 0 && (c = s), n[c] = r[s];
  }), i = _ && _.__exportStar || function(n, r) {
    for (var s in n) s !== "default" && !Object.prototype.hasOwnProperty.call(r, s) && t(r, n, s);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), i(j, e), i(S, e);
})(X);
const { min: k, seq: O, conc: et, maybe: z, oneOf: qt } = h, tt = /^[A-Za-z0-9_-]+$/imsu, P = /(?:[_\p{Ll}\p{Lu}\p{Lt}\p{Lo}\p{Nl}][_.\p{L}\p{M}\p{Nd}\p{Nl}-]*)/imsu, R = new RegExp(`${P.source}[:]${P.source}`, "imsu"), ee = new RegExp(`${P.source}[:]`, "imsu"), at = /https?:\/\//, L = /[A-Za-z](?:[A-Za-z0-9-]*[A-Za-z0-9])?/, it = O(L, k(0, O("[.]", L))), q = /%[0-9A-Fa-f]{2}/, te = /[A-Za-z0-9._~!$&'()*+,;=:@-]/, ae = k(1, q, te), nt = O(k(0, O("/", ae)), z("/")), ie = et(at, it, nt, z("#")), rt = /[A-Za-z0-9._~!$&'()*+,;=:-]/, ne = O(
  k(1, q, rt),
  k(0, q, te)
), re = O(/@/, k(1, /\d/)), st = ae, ot = {
  NCName: h.uaon(P),
  QName: h.uaon(R),
  AbbrevUri: h.uaon(ee),
  DomainLabel: h.uaon(L),
  PctEnc: h.uaon(q),
  PrefixUri: h.uaon(ie),
  DatasetItemId: h.uaon(ne),
  DatasetItemIx: h.uaon(re)
};
function Nt(e = "", t) {
  if (ot.AbbrevUri.test(e)) {
    const [i, n] = e.split(":");
    return i;
  }
  if (t === void 0)
    throw new Error(`invalid AbbrevUri: '${e}'`);
  return t;
}
const pt = {
  // ISO 639-1 code: "English Name of Language"
  aa: "Afar",
  ab: "Abkhazian",
  ae: "Avestan",
  af: "Afrikaans",
  ak: "Akan",
  am: "Amharic",
  an: "Aragonese",
  ar: "Arabic",
  as: "Assamese",
  av: "Avaric",
  ay: "Aymara",
  az: "Azerbaijani",
  ba: "Bashkir",
  be: "Belarusian",
  bg: "Bulgarian",
  bi: "Bislama",
  bm: "Bambara",
  bn: "Bengali",
  bo: "Tibetan",
  br: "Breton",
  bs: "Bosnian",
  ca: "Catalan",
  //ca: "Valencian",
  ce: "Chechen",
  ch: "Chamorro",
  co: "Corsican",
  cr: "Cree",
  cs: "Czech",
  cu: "Church Slavic",
  //cu: "Church Slavonic",
  //cu: "Old Bulgarian",
  //cu: "Old Church Slavonic",
  //cu: "Old Slavonic",
  cv: "Chuvash",
  cy: "Welsh",
  da: "Danish",
  de: "German",
  //dv: "Dhivehi",
  //dv: "Divehi",
  dv: "Maldivian",
  dz: "Dzongkha",
  ee: "Ewe",
  el: "Greek, Modern (1453-)",
  en: "English",
  eo: "Esperanto",
  //es: "Castilian",
  es: "Spanish",
  et: "Estonian",
  eu: "Basque",
  fa: "Persian",
  ff: "Fulah",
  fi: "Finnish",
  fj: "Fijian",
  fo: "Faroese",
  fr: "French",
  fy: "Western Frisian",
  ga: "Irish",
  //gd: "Gaelic",
  gd: "Scottish Gaelic",
  gl: "Galician",
  gn: "Guarani",
  gu: "Gujarati",
  gv: "Manx",
  ha: "Hausa",
  he: "Hebrew",
  hi: "Hindi",
  ho: "Hiri Motu",
  hr: "Croatian",
  //ht: "Haitian Creole",
  ht: "Haitian",
  hu: "Hungarian",
  hy: "Armenian",
  hz: "Herero",
  ia: "Interlingua (International Auxiliary Language Association)",
  id: "Indonesian",
  ie: "Interlingue",
  //ie: "Occidental",
  ig: "Igbo",
  //ii: "Nuosu",
  ii: "Sichuan Yi",
  ik: "Inupiaq",
  io: "Ido",
  is: "Icelandic",
  it: "Italian",
  iu: "Inuktitut",
  ja: "Japanese",
  jv: "Javanese",
  ka: "Georgian",
  kg: "Kongo",
  //ki: "Gikuyu",
  ki: "Kikuyu",
  kj: "Kuanyama",
  //kj: "Kwanyama",
  kk: "Kazakh",
  kl: "Greenlandic",
  //kl: "Kalaallisut",
  km: "Central Khmer",
  kn: "Kannada",
  ko: "Korean",
  kr: "Kanuri",
  ks: "Kashmiri",
  ku: "Kurdish",
  kv: "Komi",
  kw: "Cornish",
  //ky: "Kirghiz",
  ky: "Kyrgyz",
  la: "Latin",
  //lb: "Letzeburgesch",
  lb: "Luxembourgish",
  lg: "Ganda",
  li: "Limburgan",
  //li: "Limburger",
  //li: "Limburgish",
  ln: "Lingala",
  lo: "Lao",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  lv: "Latvian",
  mg: "Malagasy",
  mh: "Marshallese",
  mi: "Maori",
  mk: "Macedonian",
  ml: "Malayalam",
  mn: "Mongolian",
  mr: "Marathi",
  ms: "Malay",
  mt: "Maltese",
  my: "Burmese",
  na: "Nauru",
  //nb: "Bokmål, Norwegian",
  nb: "Norwegian Bokmål",
  //nd: "Ndebele, North",
  nd: "North Ndebele",
  ne: "Nepali",
  ng: "Ndonga",
  nl: "Dutch",
  //nl: "Flemish",
  nn: "Norwegian Nynorsk",
  //nn: "Nynorsk, Norwegian",
  no: "Norwegian",
  //nr: "Ndebele, South",
  nr: "South Ndebele",
  //nv: "Navaho",
  nv: "Navajo",
  ny: "Chewa",
  //ny: "Chichewa",
  //ny: "Nyanja",
  oc: "Occitan (post 1500)",
  oj: "Ojibwa",
  om: "Oromo",
  or: "Oriya",
  os: "Ossetian",
  //os: "Ossetic",
  //pa: "Panjabi",
  pa: "Punjabi",
  pi: "Pali",
  pl: "Polish",
  ps: "Pashto",
  //ps: "Pushto",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  //ro: "Moldavian",
  //ro: "Moldovan",
  ro: "Romanian",
  ru: "Russian",
  rw: "Kinyarwanda",
  sa: "Sanskrit",
  sc: "Sardinian",
  sd: "Sindhi",
  se: "Northern Sami",
  sg: "Sango",
  //si: "Sinhala",
  si: "Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  sm: "Samoan",
  sn: "Shona",
  so: "Somali",
  sq: "Albanian",
  sr: "Serbian",
  ss: "Swati",
  st: "Sotho, Southern",
  su: "Sundanese",
  sv: "Swedish",
  sw: "Swahili",
  ta: "Tamil",
  te: "Telugu",
  tg: "Tajik",
  th: "Thai",
  ti: "Tigrinya",
  tk: "Turkmen",
  tl: "Tagalog",
  tn: "Tswana",
  to: "Tonga (Tonga Islands)",
  tr: "Turkish",
  ts: "Tsonga",
  tt: "Tatar",
  tw: "Twi",
  ty: "Tahitian",
  ug: "Uighur",
  //ug: "Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volapük",
  wa: "Walloon",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  //za: "Chuang",
  za: "Zhuang",
  zh: "Chinese",
  zu: "Zulu"
};
X.extendZodWithOpenApi(a);
const ct = Ae();
function I(e, t) {
  return a.string().refine((i) => h.uaon(e).test(String(i)), {
    message: t
  });
}
const se = a.array(a.number()).min(2).max(2), lt = a.number(), b = a.string().regex(tt), oe = a.object({
  id: a.string()
}).and(a.record(a.string(), a.unknown())), pe = a.array(
  se.nullable(),
  lt.nullable()
), T = I(P, "Invalid NCName format"), v = I(R, "Invalid QName format"), dt = I(
  ne,
  "Invalid DatasetItemId format"
), ut = I(
  re,
  "Invalid DatasetItemIx format"
), A = a.number().int().nonnegative(), ce = I(
  st,
  "Invalid DatasetItemIdOrIx format"
), le = I(ie, "Invalid prefix URI format"), de = a.record(le, T), ue = I(ee, "Invalid abbreviated URI format"), [mt, ...ft] = Object.keys(pt), M = a.enum([mt, ...ft]), me = a.object({
  title: a.string(),
  terms: a.record(T, a.string())
}), fe = a.record(M, me), he = a.record(T, fe), ye = a.object({ preset: a.literal(!0), to: a.unknown() }), C = a.object({
  from: a.string().optional(),
  titleUri: v.optional(),
  filter: a.union([ye, a.boolean()]).optional(),
  search: a.boolean().optional()
}), be = a.object({
  type: a.literal("value"),
  as: a.union([a.literal("string"), a.literal("boolean"), a.literal("number")]).optional(),
  strict: a.boolean().optional(),
  nullable: a.boolean().optional()
}), ge = a.object({
  type: a.literal("vocab"),
  uri: ue,
  /**
   * Indicates whether the options should be sorted in filter dropdowns.
   * If set to false, no sorting will occur.
   * Sorting is set to 'asc' by default
   * If set to 'asc' or 'desc', the options will be sorted accordingly.
   */
  sorted: a.union([a.boolean(), a.literal("asc"), a.literal("desc")]).optional()
}), ht = a.union([be, ge]), yt = a.object({
  type: a.literal("multi"),
  of: ht
}), B = C.merge(be), ve = C.merge(ge), je = C.merge(yt), Ie = a.discriminatedUnion("type", [
  B,
  ve,
  je
]), we = a.object({
  // the 'id' itemProp is required, as a non-filterable ValuePropSpec
  id: B.extend({
    filter: a.literal(!1).optional()
  })
}).and(a.record(a.string(), Ie)), Z = a.object({
  itemProp: a.string(),
  valueStyle: a.union([a.literal("text"), a.literal("address"), a.literal("hyperlink")]).default("text"),
  showBullets: a.boolean().default(!1),
  singleColumnLimit: a.number().optional(),
  showLabel: a.boolean().default(!1),
  hyperlinkBaseUri: a.string().default(""),
  displayText: a.string().optional(),
  analyticOnClick: a.boolean().default(!1)
}), bt = a.record(a.string(), a.number()), ke = a.tuple([
  a.tuple([a.number(), a.number()]),
  a.tuple([a.number(), a.number()])
]), Oe = a.object({
  lockedFilter: a.array(v).nonempty(),
  mapBounds: ke.optional(),
  aboutPrefix: a.string().optional(),
  title: a.string().optional()
}), Pe = a.object({
  prefixes: de,
  vocabs: he,
  itemProps: we,
  languages: a.array(M).nonempty(),
  submaps: a.record(a.string(), Oe).optional(),
  ui: a.object({
    directory_panel_field: a.string(),
    title: a.string().optional(),
    dataLastUpdated: a.string().datetime().optional(),
    show_map_key: a.boolean().optional(),
    customMarkers: a.object({
      marker_property_name: a.string(),
      markerIcons: a.array(a.string()),
      termsToIconIndex: a.intersection(
        a.object({ default: a.number() }),
        a.record(a.number())
      )
    }).optional(),
    map: a.object({
      mapBounds: ke.optional()
    }).optional(),
    logo: a.object({
      largeLogo: a.string().optional(),
      smallLogo: a.string().optional(),
      altText: a.string().optional(),
      smallScreenPosition: a.object({
        top: a.string().optional(),
        left: a.string().optional()
      }).optional(),
      largeScreenPosition: a.object({
        bottom: a.string().optional(),
        right: a.string().optional()
      }).optional()
    }).optional()
  }),
  popup: a.object({
    titleProp: a.string(),
    leftPaneWidth: a.string().default("70%"),
    leftPane: a.array(Z),
    topRightPane: a.array(Z),
    bottomRightPane: a.array(Z)
  })
}), _e = a.object({
  name: a.string(),
  buildTime: a.string().datetime({ offset: !1 }),
  version: a.string(),
  commitDesc: a.string(),
  nodeEnv: a.string()
}), d = a.object({ message: a.string() }).passthrough(), gt = {
  AbbrevUri: ue,
  Location: se,
  ConfigData: Pe,
  DatasetId: b,
  DatasetItemId: dt,
  DatasetItemIdOrIx: ce,
  DatasetItemIx: ut,
  DatasetItemIxRaw: A,
  DatasetItem: oe,
  DatasetLocations: pe,
  FilterSpec: ye,
  I18nVocabDef: fe,
  Iso639Set1Code: M,
  MultiPropSpec: je,
  NCName: T,
  PrefixUri: le,
  PrefixIndex: de,
  PropSpec: Ie,
  PropSpecs: we,
  QName: v,
  SubmapDef: Oe,
  ValuePropSpec: B,
  BuildInfo: _e,
  VocabDef: me,
  VocabIndex: he,
  VocabPropSpec: ve,
  ErrorInfo: d
}, St = ct.router({
  getDatasetLocations: {
    method: "GET",
    path: "/dataset/:datasetId/locations",
    summary: "obtains a dataset's locations",
    description: "Obtains all the locations for a dataset by the dataset ID, which by passing in the appropriate options, might be in different formats",
    pathParams: a.object({
      datasetId: b.openapi({
        description: "uniquely specifies the dataset wanted"
      })
    }),
    responses: {
      200: pe.openapi({
        description: "the dataset matching the supplied ID"
      }),
      400: d.openapi({
        description: "bad input parameter"
      }),
      404: d.openapi({
        description: "no such dataset"
      })
    }
  },
  searchDataset: {
    method: "GET",
    path: "/dataset/:datasetId/search",
    summary: "obtains a list of dataset entries satisfying the search criteria supplied",
    description: "Obtains an array of dataset item indexes, which match the search criteria supplied",
    query: a.object({
      text: a.string().optional().openapi({
        description: "a text fragment to match"
      }),
      // Change singular params to arrays (so that a single filter is possible!)
      // see https://github.com/ts-rest/ts-rest/issues/290#issuecomment-1658983510
      filter: a.array(v).or(v.transform((e) => [e])).optional().openapi({
        description: "uniquely specifies the taxonomy filter items wanted"
      }),
      returnProps: a.array(a.string()).optional().openapi({
        description: "The props to return as an array of item objects. If not specified, only an flattened array of indexes is returned."
      }),
      page: a.coerce.number().int().nonnegative().optional().openapi({
        description: "The page number to return. If not specified, all items are returned."
      }),
      pageSize: a.coerce.number().int().positive().optional().openapi({
        description: "The number of items per page. If not specified, all items are returned."
      })
    }),
    pathParams: a.object({
      datasetId: b.openapi({
        description: "uniquely specifies the dataset wanted"
      })
    }),
    responses: {
      200: a.union([
        a.array(A),
        a.array(
          a.record(a.string(), a.unknown()).and(a.object({ index: A }))
        )
      ]).openapi({
        description: "the dataset item indexes matching the supplied criteria"
      }),
      400: d.openapi({
        description: "bad input parameter"
      }),
      404: d.openapi({
        description: "no such dataset"
      })
    }
  },
  getDatasetItem: {
    method: "GET",
    path: "/dataset/:datasetId/item/:datasetItemIdOrIx",
    summary: "obtains a dataset item by its unique ID",
    description: "Obtains a single dataset item by its ID or its index, and the dataset's ID.",
    pathParams: a.object({
      datasetId: b.openapi({
        description: "uniquely specifies the dataset wanted"
      }),
      datasetItemIdOrIx: ce.openapi({
        description: "Uniquely specifies the dataset item wanted within the dataset. This param must be base64 encoded. The decoded param should start with an @ to indicate an index, otherwise it is assumed to be an id"
      })
    }),
    query: a.object({
      returnProps: a.array(a.string()).optional().openapi({
        description: "The props to return. If not specified, all props are returned. Note that the item's ID and index are always returned."
      })
    }),
    responses: {
      200: oe.and(a.object({ index: A })).openapi({
        description: "the dataset item matching the supplied ID or index"
      }),
      400: d.openapi({
        description: "bad input parameter"
      }),
      404: d.openapi({
        description: "no such dataset or dataset item"
      })
    }
  },
  getTotals: {
    method: "GET",
    path: "/dataset/:datasetId/totals",
    summary: "get the total number of results under each item in the directory",
    description: "Gets the total number of results under each item in the directory.",
    pathParams: a.object({
      datasetId: b.openapi({
        description: "uniquely specifies the dataset wanted"
      })
    }),
    query: a.object({
      // Promote singular parameters to arrays, as in searchDataset
      filter: a.array(v).or(v.transform((e) => [e])).optional().openapi({
        description: "restricts the totals to items matching these taxonomy filters"
      })
    }),
    responses: {
      200: bt.openapi({
        description: "the total result numbers for a map"
      }),
      400: d.openapi({
        description: "bad input parameter"
      }),
      404: d.openapi({
        description: "no such dataset"
      })
    }
  },
  getConfig: {
    method: "GET",
    path: "/dataset/:datasetId/config",
    summary: "obtain various configured parameters for a dataset",
    description: "Obtains configured parameters for a datset, which amongst other things, include default values for various options, and definitions of vocabulary terms with their localised labels, that are used to interpret identifers in the data and/or elsewhere.",
    pathParams: a.object({
      datasetId: b.openapi({
        description: "uniquely specifies the dataset wanted"
      })
    }),
    responses: {
      200: Pe.openapi({
        description: "various configured parameters for a map"
      }),
      400: d.openapi({
        description: "bad input parameter"
      }),
      404: d.openapi({
        description: "no such dataset"
      })
    }
  },
  getAbout: {
    method: "GET",
    path: "/dataset/:datasetId/about",
    summary: "obtain the About text for a dataset",
    description: "Obtains information about the datset, in markdown format so it can be easily rendered on a front-end application.",
    pathParams: a.object({
      datasetId: b.openapi({
        description: "uniquely specifies the dataset wanted"
      })
    }),
    responses: {
      200: a.string().openapi({
        description: "About text in markdown format"
      }),
      400: d.openapi({
        description: "bad input parameter"
      }),
      404: d.openapi({
        description: "no such dataset"
      })
    }
  },
  getVersion: {
    method: "GET",
    path: "/version",
    summary: "obtains Mykomap server version information",
    description: "Obtains version information about the backend Mykomap server, in the form of a JSON object",
    responses: {
      200: _e.openapi({
        description: "information about the current Mykomap server build"
      })
    }
  },
  listDatasets: {
    method: "GET",
    path: "/datasets",
    summary: "lists the datasets available on this server",
    description: "Returns an array of the datasets available on this server, each entry carrying the dataset ID, a human-readable label (taken from config.ui.logo.altText, falling back to the ID), and the dataset's submaps (key and title), if any. A dataset that is a symlink to another dataset (such as cwm-latest) also carries aliasOf, the ID of the dataset it points at.",
    responses: {
      200: a.array(
        a.object({
          id: b,
          label: a.string(),
          aliasOf: b.optional(),
          submaps: a.array(a.object({ key: a.string(), title: a.string() })).optional()
        })
      ).openapi({
        description: "the list of available datasets"
      })
    }
  }
}), Y = (e) => e.reduce((t, i) => It(t, i), void 0), H = (e) => e.reduce((t, i) => jt(t, i), void 0), Tt = (e) => typeof e == "boolean";
function vt(e) {
  switch (e.trim().toLowerCase()) {
    case "true":
    case "t":
    case "yes":
    case "y":
    case "1":
      return !0;
    case "false":
    case "f":
    case "no":
    case "n":
    case "0":
      return !1;
    default:
      return;
  }
}
function Zt(e, t = !1) {
  if (e == null) return t;
  switch (typeof e) {
    case "string":
      return vt(e) ?? t;
    case "bigint":
    case "number":
      return e == 0;
    case "boolean":
      return e;
    case "object":
      return t;
    case "symbol":
    case "undefined":
    case "function":
    default:
      return t;
  }
}
const Et = (e) => typeof e == "string", xe = (e, t = "") => typeof e == "string" ? e : t, Q = (e, t = 0) => isNaN(e) ? t : e, Lt = (e) => typeof e == "number", Ut = (e) => typeof e == "number" && !isNaN(e);
function x(e, t = 0) {
  switch (typeof e) {
    case "number":
      return Q(e, t);
    case "string":
      return Q(Number.parseFloat(e), t);
    default:
      return t;
  }
}
function N(e) {
  return !(!(e instanceof Array) || e.length < 2 || e.length !== 2 || typeof e[0] != "number" || isNaN(e[0]) || typeof e[1] != "number" || isNaN(e[1]));
}
function J(e, t) {
  if (e instanceof Array) {
    if (e.length == 2 && typeof e[0] == "number" && typeof e[1] == "number")
      return e;
    if (e.length < 2) return t;
    const i = x(e[0], null), n = x(e[1], null);
    return typeof i == "number" && typeof n == "number" ? [i, n] : t;
  }
  if (e instanceof Object) {
    if ("0" in e && "1" in e) {
      const i = x(e[0], null), n = x(e[1], null);
      if (typeof i == "number" && typeof n == "number") return [i, n];
    }
    return t;
  }
  return t;
}
function Mt(e) {
  return !(!(e instanceof Array) || e.length < 2 || e.length !== 2 || !N(e[0]) || !N(e[1]));
}
function Ct(e) {
  return Number.isFinite(e[0][0]) && Number.isFinite(e[0][1]) && Number.isFinite(e[1][0]) && Number.isFinite(e[1][1]);
}
function Bt(e, t) {
  if (e instanceof Array && e.length >= 2) {
    if (N(e[0]) && N(e[1]))
      return e.length === 2 ? e : [e[0], e[1]];
    const i = J(e[0], null), n = J(e[0], null);
    if (i && n) return [i, n];
  }
  return t;
}
function $t(e, t) {
  return e ? t ? [
    [
      Math.min(e[0][0], e[1][0], t[0][0], t[1][0]),
      Math.min(e[0][1], e[1][1], t[0][1], t[1][1])
    ],
    [
      Math.max(e[0][0], e[1][0], t[0][0], t[1][0]),
      Math.max(e[0][1], e[1][1], t[0][1], t[1][1])
    ]
  ] : e : t || void 0;
}
function jt(e, t) {
  return e == null ? t ?? void 0 : t == null || e < t ? e : t;
}
function It(e, t) {
  return e == null ? t ?? void 0 : t == null || e > t ? e : t;
}
function Vt(e, t) {
  let i = H(e);
  if (i === void 0) return;
  let n = H(t);
  if (n === void 0) return;
  let r = Y(e);
  if (r === void 0) return;
  let s = Y(t);
  if (s !== void 0)
    return [
      [i, n],
      [r, s]
    ];
}
function Ft(e) {
  return e instanceof Array ? e : e == null ? [] : [e];
}
const Gt = (e) => e !== void 0, wt = (e) => e != null;
function Kt(e) {
  return e ? e.filter(wt) : [];
}
function Wt(e, t) {
  if (!e) throw new Error(t);
}
function Yt(e, t) {
  const i = /* @__PURE__ */ new Set();
  return e.forEach((n) => {
    t(n) && i.add(n);
  }), i;
}
function Ht(e, t) {
  let i = "";
  const n = [];
  let r = !1;
  for (var s of e) {
    if (r) {
      i += s, r = !1;
      continue;
    }
    switch (s) {
      case t.delim:
        n.push(i), i = "";
        break;
      case t.escape:
        r = !0;
        break;
      default:
        i += s;
    }
  }
  return n.push(i), n;
}
function kt(e) {
  return e.name.replace(/[\/\\\s]+/g, "") + "@" + e.version;
}
function Ot(e) {
  return e.commitDesc.split("-").slice(2).join("-");
}
function Qt(e) {
  Object.keys(e).forEach((t) => delete e[t]);
}
class Jt {
  /** Normalises a text string into an indexable form.
   *
   * Performs these steps:
   * - Lower-cases it
   * - Eliminates non word-breaking punctuation (`\`'`)
   * - Converts all other punctuation to space characters.
   * - Deduplicates whitespace
   * - Trims whitespace from front and back of the string.
   */
  static normalise(t) {
    return t.toLowerCase().replace(/['`]/, "").replace(/[^\w ]+/g, " ").replace(/\s+/g, " ").trim();
  }
}
class Xt {
  _vocabs;
  /** Constructor.
   *
   * @param vocabs - all the vocab definitions we will require to create VocabPropDefs.
   * @param checkLangs - if given, check that the vocabs include translations for these languages.
   */
  constructor(t, i) {
    if (this._vocabs = gt.VocabIndex.parse(t), i) {
      const n = [];
      for (const r in this._vocabs) {
        const s = this._vocabs[r];
        i.every((c) => c in s) || n.push(r);
      }
      if (n.length)
        throw new Error(
          `PropDefServices initialised with these Vocabs which are incompatible with the target languages '${i}': ${n}`
        );
    }
  }
  /** Looks up an interationalised vocab given its URI */
  i18nVocabDef(t) {
    const i = t.replace(/:$/, ""), n = this._vocabs[i];
    if (n == null) throw new Error(`unknown vocab URI: '${t}'`);
    return n;
  }
  mkPropDef(t) {
    switch (t.type) {
      case "value":
        return new Pt(t);
      case "vocab":
        return new De(t, this.i18nVocabDef(t.uri));
      case "multi":
        const i = this.mkPropDef(t.of);
        return new _t({ ...t, of: i });
    }
  }
  /** Make a Record of indexed PropDefs from a Dictionary of ProfSpecs
   *
   *
   * @param specs - a Dictionary of PropSpecs.
   * @returns A record of PropDefs, indexed by the same keys as the
   * relevant PropSpec.
   *
   * A Dictionary may have undefined elements; a Record, by definition, doesn't.
   * This function should honour that, and guarantee none.
   */
  mkPropDefs(t) {
    const i = {};
    for (const n in t) {
      const r = t[n];
      r != null && (i[n] = this.mkPropDef(r));
    }
    return i;
  }
}
class $ {
  from;
  titleUri;
  filter;
  search;
  /** Constructor.
   *
   * @param init - the specification to use
   */
  constructor(t) {
    this.from = t.from, this.titleUri = t.titleUri, this.filter = t.filter ?? !1, this.search = !!t.search;
  }
  /** @return true if and only if a filter should be created for this PropDef */
  isFiltered() {
    return !!this.filter;
  }
}
class Pt extends $ {
  /** The type specifier */
  type = "value";
  /** Conversion hints */
  as;
  nullable;
  strict;
  /** Constructor
   * @param init - the specification for the ValuePropDef
   */
  constructor(t) {
    super(t), this.as = t.as, this.nullable = t.nullable === !0, this.strict = t.strict === !0;
  }
  /**
   * This is always undefined for instances of this class, as they don't have URIs.
   */
  get uri() {
  }
  textForValue(t) {
    return t === void 0 ? void 0 : xe(t);
  }
}
class De extends $ {
  /** Constructor
   * @param init - the specification for the VocabPropDef
   * @param i18nVocab - the internationalised vocab definitions to use
   */
  constructor(t, i) {
    super(t), this.i18nVocab = i, this.uri = t.uri;
  }
  /** The type specifier */
  type = "vocab";
  /** The (abbreviated) vocabulary URI */
  uri;
  /** Looks up a localised vocab, given a language code */
  localisedVocabDef(t) {
    const i = this.i18nVocab[t];
    if (i == null)
      throw new Error(
        `no terms defined for language code '${t}' in vocab '${this.uri}'`
      );
    return i;
  }
  textForValue(t, i) {
    if (i === void 0)
      throw new Error(`no language code provided for vocab '${this.uri}'`);
    return typeof t == "string" ? this.localisedVocabDef(i).terms[t] : "";
  }
}
class _t extends $ {
  type = "multi";
  of;
  /**
   * This indicates the vocab URI in use if pertinent. It is undefined otherwise
   */
  get uri() {
    if (this.of.type === "vocab") return this.of.uri;
  }
  /**
   * This indicates the internationalised vocab definition in use if it contains vocab values. It
   * is undefined otherwise.
   */
  i18nVocab;
  /** Constructor
   *
   * @param init - the specification for this MultiPropSpec. Note, we insist on
   * the of: parameter to be concrete so we can delegate getTextForProperty
   * calls to it.
   */
  constructor(t) {
    super(t), this.of = t.of, t.of instanceof De && (this.i18nVocab = t.of.i18nVocab);
  }
  textForValue(t, i) {
    return t instanceof Array ? t.map((n) => xe(this.of.textForValue(n, i))) : [];
  }
}
function zt(e) {
  const t = e.split(/\r?\n/, 1)[0] ?? "", i = t.match(
    /^# v(\d+\.\d+\.\d+(?:\+\d+)?) - \d{4}-\d{2}-\d{2}$/
  );
  if (!i)
    throw new Error(
      `CHANGELOG.md must start with "# vX.Y.Z - YYYY-MM-DD", found "${t}"`
    );
  return i[1];
}
class Rt {
  /** A stub method for executing commands.
   *
   * Typically this will be a reference to `spawnSync`, provided by NodeJS. But
   * since we want this class to be defined without NodeJS dependencies, so it
   * can be included everywhere and only used in vite.config.ts, it needs to be
   * provided via the constructor.
   */
  exec;
  /** The environment variables to consult, typically process.env */
  env;
  /** The name of the software component */
  name;
  /* The time it was built. Should be a UTC ISO string as returned by Date.toISOString() */
  buildTime;
  /** The commit descriptor. Should be a string as returned by gitDescribe() */
  commitDesc;
  /** The version from package.json, e.g. "4.2.0" or "4.2.1+1" for a hotfix */
  version;
  /** The build environment. A string, typically 'development' or 'production',
   * but may be an empty string if nothing is set */
  nodeEnv;
  /** Convenience method to get a sentryRelease string for this instance */
  get sentryRelease() {
    return kt(this);
  }
  /** Convenience method to get a sentryDist string for this instance */
  get sentryDist() {
    return Ot(this);
  }
  /** Get the git-describe commit information.
   *
   * The result will be a string with the format: "[<TAG>-<COUNT>-]<COMMIT-ID>[-dirty]"
   * - Items in square brackets may be absent.
   * - TAG is the last "versiony" tag found in the commit history, if there is one,
   *   otherwise this and the next dash delimiter are omitted.
   * - COUNT is the number of commts from the tag (or the first commit if none) to the current commit.
   * - COMMIT-ID is the abbreviated SHA1 commit ID.
   * - A "dirty" suffix indicates a build in a dirty working directory.
   * - Note that TAG may contain any character a tag can, including a hyphen.
   * - Therefore it might not be a version string.
   *
   * A "versiony" tag begins with a `v` followed by decimal numbers delimited
   * by single periods.
   *
   * Returns an empty string when git is not available or this is not a git
   * checkout.
   */
  gitDescribe() {
    try {
      return this.exec("git", [
        "describe",
        "--tags",
        "--match=v[0-9]*",
        "--exclude=v*[^0-9.]*",
        "--always",
        "--long",
        "--dirty"
      ]).trim();
    } catch {
      return "";
    }
  }
  /** Describe the commit from the environment when there is no git checkout.
   *
   * Coolify sets SOURCE_COMMIT to the full commit ID when it builds an image
   * and the Dockerfiles pass it through as a build argument. It is shortened
   * to match the abbreviated ID `git describe` gives.
   */
  envDescribe() {
    return (this.env.SOURCE_COMMIT?.trim() ?? "").substring(0, 7);
  }
  /** Constuctor.
   *
   * `name` and `version` are required and come from package.json. The commit
   * description is inferred from git, then SOURCE_COMMIT, unless given.
   */
  constructor(t) {
    this.exec = t.exec, this.env = t.env, this.name = t.name, this.version = t.version, this.buildTime = t.buildTime ?? (/* @__PURE__ */ new Date()).toISOString(), this.commitDesc = t.commitDesc || this.gitDescribe() || this.envDescribe() || "unknown", this.nodeEnv = t.nodeEnv ?? this.env.NODE_ENV ?? "", Object.defineProperty(this, "exec", { enumerable: !1 }), Object.defineProperty(this, "env", { enumerable: !1 });
  }
}
export {
  ee as AbbrevUri,
  $ as CommonPropDef,
  ne as DatasetItemId,
  st as DatasetItemIdOrIx,
  re as DatasetItemIx,
  pt as Iso639Set1Codes,
  _t as MultiPropDef,
  P as NCName,
  ie as PrefixUri,
  Xt as PropDefsFactory,
  R as QName,
  Rt as ReadonlyBuildInfo,
  h as RxUtils,
  Jt as TextSearch,
  ot as UAON,
  tt as UrlSafeBase64,
  Pt as ValuePropDef,
  De as VocabPropDef,
  Y as arrayMax,
  H as arrayMin,
  Vt as arrays2Box2d,
  Wt as assert,
  Zt as boolify,
  $t as box2dUnion,
  zt as changelogVersion,
  Qt as clear,
  Kt as compactArray,
  St as contract,
  Yt as filterSet,
  It as highest,
  Tt as isBool,
  Mt as isBox2d,
  Ct as isFiniteBox2d,
  Lt as isNumber,
  N as isPoint2d,
  Et as isString,
  jt as lowest,
  wt as notNullish,
  Gt as notUndefined,
  x as numberify,
  Nt as parseAbbrevUri,
  Ft as promoteToArray,
  gt as schemas,
  Ot as sentryDist,
  kt as sentryRelease,
  At as specification,
  Ht as splitField,
  xe as stringify,
  vt as textToBool,
  Bt as toBox2d,
  J as toPoint2d,
  Q as toYesANumber,
  Ut as yesANumber
};
